import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { GridViewComponent } from '../shared/components/grid-view/grid-view.component';
import { TestService } from '../shared/services/test.service';

@Component({
  selector: 'app-test',
  templateUrl: './test.component.html'
})

export class TestComponent implements OnInit {
  //#region Properties & Variables
  //Dummy Collection Properties
  private fruits: Fruit[] = [];
  private cars: Car[] = [];
  //Collection Properties
  private collection = [];
  //Items Menu Array
  private itemsMenu: MenuItem[] = [];
  //#endregion

  //@ViewChild('gv1') gridViewFruits: GridViewComponent;
  //@ViewChild('gv2') gridViewCars: GridViewComponent;
  @ViewChild('gvTest',{static: false}) gridViewTest: GridViewComponent;

  constructor(private testService: TestService) { }

  ngOnInit() {
    //this.loadDummyCollection();
    //this.gridViewCars.loadGrid(this.cars, 2);
    this.loadItemsMenu();
    this.loadCollection();
  }

  loadDummyCollection() {
    //Date => MM/DD/YYYY
    this.fruits[0] = new Fruit();
    this.fruits[0].Id = 3;
    this.fruits[0].Name = "Banana";
    this.fruits[0].FoundDate = "11/06/2000";
    this.fruits[1] = new Fruit();
    this.fruits[1].Id = 1;
    this.fruits[1].Name = "Lemon";
    this.fruits[1].FoundDate = "03/22/2004";
    this.fruits[2] = new Fruit();
    this.fruits[2].Id = 2;
    this.fruits[2].Name = "Apple";
    this.fruits[2].FoundDate = "09/17/2008";
    this.fruits[3] = new Fruit();
    this.fruits[3].Id = 4;
    this.fruits[3].Name = "Avocado";
    this.fruits[3].FoundDate = "04/25/2011";
    this.fruits[4] = new Fruit();
    this.fruits[4].Id = 5;
    this.fruits[4].Name = "BlackBerry";
    this.fruits[4].FoundDate = "05/14/2015";
    this.fruits[5] = new Fruit();
    this.fruits[5].Id = 6;
    this.fruits[5].Name = "Cherry";
    this.fruits[5].FoundDate = "11/23/2016";
    this.fruits[6] = new Fruit();
    this.fruits[6].Id = 7;
    this.fruits[6].Name = "Date";
    this.fruits[6].FoundDate = "07/07/2017";
    this.fruits[7] = new Fruit();
    this.fruits[7].Id = 8;
    this.fruits[7].Name = "Mango";
    this.fruits[7].FoundDate = "11/06/2019";

    this.cars[0] = new Car();
    this.cars[0].Id = 1;
    this.cars[0].Name = "A";
    this.cars[1] = new Car();
    this.cars[1].Id = 2;
    this.cars[1].Name = "B";
    this.cars[2] = new Car();
    this.cars[2].Id = 3;
    this.cars[2].Name = "C";
  }

  loadCollection() {
    this.testService.getAllPagedSorted(0, 3, 'Id', 'ASC').subscribe(
      data => this.collection = data.Data,
      () => console.log("Something went wrong!!"),
      () => this.loadCollectionCompleted()
    );
  }

  loadCollectionCompleted() {
    //this.gridViewTest.loadGrid(this.collection, 8, 3, "Test/GetAllPagedSorted", "FRONT_USER.Test_Form", this.itemsMenu);
  }

  loadItemsMenu() {
    this.itemsMenu[0] = new MenuItem();
    this.itemsMenu[0].Title = "Details";
    this.itemsMenu[0].Url = "/html";
    this.itemsMenu[0].Replacement = "Id,NamEN";
    this.itemsMenu[1] = new MenuItem();
    this.itemsMenu[1].Title = "Edit";
    this.itemsMenu[1].Url = "/Edit/{0}";
    this.itemsMenu[1].Replacement = "Id";
  }
}

export class Fruit {
  Id :number;
  Name :string;
  FoundDate: string;
};

export class Car {
  Id :number;
  Name :string;
};

export class MenuItem {
  Title :string;
  Url :string;
  Replacement: string;
};
